import { Wallet, Sparkles } from 'lucide-react';

export default function Refund() {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-wrapper" style={{ paddingBottom: '4rem' }}>
        <div className="grid-2">
          <div>
            <span className="section-label">
              <Sparkles size={14} style={{ marginRight: '0.4rem', verticalAlign: 'middle' }} />
              Refund Policy
            </span>
            <h1 className="hero-gradient-text" style={{ fontSize: '3rem' }}>
              Refund policy terms for Roriri
            </h1>
            <p className="section-desc" style={{ fontSize: '1.2rem', marginBottom: '2.5rem' }}>
              Read our refund policy, including the conditions, process, and eligibility rules.
            </p>
          </div>

          <div className="hero-mockup-wrapper" style={{ padding: '2rem' }}>
            <div className="premium-card" style={{ padding: '2rem', display: 'flex', gap: '1.5rem', alignItems: 'center', margin: 0 }}>
              <div className="icon-box" style={{ margin: 0, flexShrink: 0 }}>
                <Wallet size={32} />
              </div>
              <div>
                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.25rem' }}>Clear & Fair</h3>
                <p style={{ margin: 0, fontSize: '0.95rem' }}>Our refund policy outlines transparent guidelines for SaaS, custom designs, and self-hosted models.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Refund Content Section */}
      <section style={{ borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)', background: 'rgba(241, 245, 249, 0.2)' }}>
        <div className="section-wrapper">
          <div className="legal-container">
            <div className="legal-body-card">
              <h2>Introduction</h2>
              <p>At Roriri Soft Solutions, we strive to ensure customer satisfaction. This Refund Policy explains when refunds may be requested for our products and services.</p>

              <h2>1. SaaS Product Refund</h2>
              <p>15-Day Money-Back Guarantee: Request a full refund within 15 days of your initial purchase or subscription start date.</p>
              <p><strong>Conditions:</strong></p>
              <ul>
                <li>The refund request must be submitted within 15 days.</li>
                <li>You must provide a valid reason for the refund request.</li>
                <li>The refund will be processed to the original payment method.</li>
                <li>Access to the platform may be revoked upon approval.</li>
              </ul>

              <h2>2. Downloadable Product Refund</h2>
              <p><strong>Before Download:</strong> Full refund within 7 days if the product has not been downloaded.</p>
              <p><strong>After Download:</strong> No refunds after the product has been downloaded.</p>
              <p>We track download activity to verify eligibility and protect our digital intellectual property.</p>

              <h2>3. Customization Services Refund</h2>
              <p><strong>Before Customization Starts:</strong> Full refund within 7 days of payment if work has not begun.</p>
              <p><strong>After Customization Starts:</strong> Refunds are pro-rated based on work completed.</p>
              <p>Refund amount = Total payment - (Percentage of work completed × Total payment).</p>

              <h2>4. Refund Request Process</h2>
              <p>Submit a refund request via email to <a href="mailto:admin@roririsoft.com">admin@roririsoft.com</a> with your name, order number, product type, reason, and purchase date.</p>
              <p>We will review your request and respond within 2-3 business days. Approved refunds typically process within 7-10 business days.</p>

              <h2>5. Non-Refundable Items</h2>
              <p>Refunds are not available for downloaded products, items purchased beyond the refund period, third-party services, promotional or discounted items, and training already delivered.</p>

              <h2>6. Payment Method & Processing Time</h2>
              <p>Refunds are issued to the original payment method in the same currency. Processing time may vary by bank or provider.</p>

              <h2>7. Exceptions & Special Cases</h2>
              <p>We may make exceptions in cases such as technical issues, billing errors, or undelivered services.</p>

              <h2>8. Contact Us</h2>
              <p>
                If you have questions about refunds, contact us at{' '}
                <a href="mailto:admin@roririsoft.com">admin@roririsoft.com</a>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
